import { render } from "./ManageCompany.vue?vue&type=template&id=6a645d66&scoped=true"
import script from "./ManageCompany.vue?vue&type=script&lang=js"
export * from "./ManageCompany.vue?vue&type=script&lang=js"

import "./ManageCompany.vue?vue&type=style&index=0&id=6a645d66&lang=css"
import "./ManageCompany.vue?vue&type=style&index=1&id=6a645d66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a645d66"]])

export default __exports__